import {
  Wrapper,
  OverlayClose,
  Icon,
  Link,
  SessionRole,
  OverlayMenu,
  Inserter,
} from "nystem-components";
import React from "react";
import app from "nystem";
import "./menu.css";

const MenuItem = ({ to, icon, text, exact }) => (
  <OverlayClose renderAs="div">
    <Link className="" to={to} exact={exact}>
      <Icon className="h-6 w-6 m-3" icon={icon} />
      <Wrapper renderAs="b" className="rn-menu-item-text">
        {app.t(text)}
      </Wrapper>
    </Link>
  </OverlayClose>
);

const MenuItemExt = ({ to, icon, text }) => (
  // eslint-disable-next-line
  <a className="" href={to} target="_blank" rel="noopener">
    <Icon className="h-6 w-6 m-3" icon={icon} />
    <Wrapper renderAs="b" className="rn-menu-item-text">
      {app.t(text)}
    </Wrapper>
  </a>
);

const PartMenu = () => (
  <OverlayMenu>
    <Wrapper className="part-menu-items setFocus">
      <OverlayClose className="part-menu-item" renderAs="a">
        <Icon className="h-6 w-6 m-3" icon="xmark" />
        <Wrapper renderAs="b" className="rn-menu-item-text back-button-text">
          {" "}
        </Wrapper>
      </OverlayClose>
      <MenuItem to="/" exact={true} text="Hem" icon="house" />
      <Inserter match="/*" source="/page/menuitems" />
      <MenuItemExt
        to="https://www.instagram.com/yintangakupunktur/"
        text="Instagram"
        icon="brands-instagram"
      />
      <MenuItemExt
        to="https://www.facebook.com/yintangakupunktur/"
        text="Facebook"
        icon="brands-facebook"
      />
      <SessionRole userrole="super config" className="navbar-nav mr-auto">
        <MenuItem to="/admin/page/list" text="Admin" icon="gear" />
      </SessionRole>
    </Wrapper>
  </OverlayMenu>
);
export default PartMenu;
